import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";

import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import pickupStartCity from '../../../../components/userCenter/public/pickupStartCity.vue'
import pickupEndCity from '../../../../components/userCenter/public/pickupEndCity.vue'

//import {BaiduMap, } from 'vue-baidu-map/components/map/Map.vue' //百度地图局部应用
//import BMapLib from 'BMapLib'

export default {
    components: { menberMenu, pickupStartCity, pickupEndCity,  },
    
    data() {
        return {
            api: {
                url: "",
                param: "",
                data: "",
                response: {},
                message: ""
            },

            titNames: "Pick-up service",
            titUrls: ",",

            showList: 0,

            //起运城市存值
            startCityNameEn: '',
            startCityNameEn1: '',
            startCityKey: '',
            startCityNameCh: '',
            //目的城市存值
            endCityNameEn: '',
            endCityNameEn1: '',
            endCityNameCh: '',
            endCityKey: '',
            // yzSuccess: false, //下单后为true 验证是否成功  用在从编辑回退时的判断

            //预约时间
            // mentTime:[],
            // servTimeOptions:[
            //   // {value: 'zhinan',label: '指南',children: [{ value: 'yizhi',label: '一致'}],}
            // ],

            mentTime: new Date(), //货好时间
            datePickerOptions: {
                disabledDate: (time) => {
                    return time.getTime() < new Date(new Date()).setDate(new Date().getDate() - 1);
                }
            },

            selectedOptionsTip: false,
            plaCas: '',

            radioUnits: 0, //单位选择

            carWeight: '',
            carVolume: '',

            tipsTextVol: false,
            isShowRed: false,

            center: { lng: 0, lat: 0 },
            zoom: 3,
            distance: 0, //行驶距离
            markerPoint: '',

            //
            startLng: '',
            startLat: '',
            endLng: '',
            endLat: '',

            //查价取件列表
            ThQueryList: [],

            //分页
            currentPage: 1, //当前页数
            pageSize: 10, //，每页显示的条数
            total: 0, //查询结果条数


        };
    },

    created() { //创建后

    },
    mounted() { //载入dom后周期函数
        this.setServTimeApi();
         document.body.style.backgroundColor = '#F0F2F5'
    },
    watch: {},
    computed: { //计算属性周期函数

    },
    methods: {

        //获取经纬度搜索
        mapApi() {
            let that = this
            var map = new BMap.Map("mapBaidu");
            map.centerAndZoom(new BMap.Point(114.064552, 22.548456), 15);

            //获取经纬度，
            function myFun() {
                var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
                //console.log('经度：'+pp.lng, '纬度：'+pp.lat);
                that.startLng = pp.lng
                that.startLat = pp.lat
                //console.log('经度：' + that.startLng, '经度：' + that.startLat);
                that.showMapBox2() //调用百度地图
            }

            function myFun2() {
                var pp2 = local2.getResults().getPoi(0).point; //获取第一个智能搜索的结果
                //console.log('经度2：'+pp2.lng, '纬度2：'+pp2.lat);
                that.endLng = pp2.lng
                that.endLat = pp2.lat
                //console.log('经度2：' + that.endLng, '纬度2：' + that.endLat);
                that.showMapBox2() //调用百度地图
            }

            var local = new BMap.LocalSearch(map, { //智能搜索
                onSearchComplete: myFun
            });
            var local2 = new BMap.LocalSearch(map, { //智能搜索
                onSearchComplete: myFun2
            });
            local.search(that.startCityNameCh);
            local2.search(that.endCityNameCh);
        },
        //
        showMapBox2() {
            let that = this
            var map = new BMap.Map("mapBaidu");
            map.centerAndZoom(new BMap.Point(114.064552, 22.548456), 15);
            var driving = new BMap.DrivingRoute(map, {
                renderOptions: {
                    map: map,
                    autoViewport: true
                }
            });

            var start = new BMap.Point(that.startLng, that.startLat);
            var end = new BMap.Point(that.endLng, that.endLat);
            driving.search(start, end);

            var html = ["<div class='infoBoxContent'>" + this.startCityNameEn + "</div>"];
            var infoBox = new BMapLib.InfoBox(map, html.join(""), {
                boxStyle: {
                    background: "#fff",
                    width: "100px",
                    height: "20px",
                    padding: "5px",
                    border: "1px solid #ddd",
                },
                closeIconMargin: "0",
                enableAutoPan: true,
                align: INFOBOX_AT_TOP,
                offset: new BMap.Size(10, -20) //infobox偏移量
            });

            var html2 = ["<div class='infoBoxContent'>" + this.endCityNameEn + "</div>"];
            var infoBox2 = new BMapLib.InfoBox(map, html2.join(""), {
                boxStyle: {
                    background: "#fff",
                    width: "100px",
                    height: "20px",
                    padding: "5px",
                    border: "1px solid #ddd",
                },
                closeIconMargin: "0", //关闭图标距离右上角的间距
                enableAutoPan: true, //自动偏移
                //关闭图标的图片路径
                align: INFOBOX_AT_TOP, //infobox显示位置，目前只有上和下
                offset: new BMap.Size(10, -20) //infobox偏移量
            });

            infoBox.addEventListener('open', function(type, target, point) { //窗口打开是，隐藏自带的关闭按钮
                $('.infoBox>img').hide();
            })

            var startIcon = new BMap.Icon(('../../../static/img/mapIcon.png'), new BMap.Size(20, 20), { anchor: new BMap.Size(13, 10), });
            var endIcon = new BMap.Icon(('../../../static/img/mapIcon.png'), new BMap.Size(20, 20), { anchor: new BMap.Size(13, 10), });
            driving.setMarkersSetCallback(function(result) {
                //在坐标点上先删除图标，在创建一个新的图标，去掉原有的自带的点击事件
                var markerstart = new BMap.Marker(result[0].marker.getPosition(), { icon: startIcon }); // 创建点
                map.addOverlay(markerstart);
                map.removeOverlay(result[0].marker); //删除起点

                var markerEnd = new BMap.Marker(result[1].marker.getPosition(), { icon: endIcon }); // 创建点
                map.addOverlay(markerEnd);
                map.removeOverlay(result[1].marker); //删除起点

                infoBox.open(result[0].marker);
                infoBox2.open(result[1].marker);

            })

            //重新设置路线颜色
            driving.setSearchCompleteCallback(function(results) {
                //driving.clearResults();
                if (driving.getStatus() != BMAP_STATUS_SUCCESS) {
                    return;
                }
                //var plan = driving.getResults().getPlan(0);
                var plan = results.getPlan(0);
                for (var i = 0; i < plan.getNumRoutes(); i++) {
                    var pts = plan.getRoute(i).getPath();　　　　 //重点在这   这个地方是关于修改颜色的
                    var polyline = new BMap.Polyline(pts, { strokeColor: "", strokeWeight: 5, strokeOpacity: 1, timeOptions: 1 });
                    map.addOverlay(polyline);
                }
                // 计算两地之间驾车距离
                that.distance = parseInt(plan.getDistance(false)) / 1000; // 驾车距离就是他了

            });
        },

        //如果起运地目的相同
        showMapSame() {
            let that = this
            var map = new BMap.Map("mapBaidu");
            var point = new BMap.Point(114.064552, 22.548456);
            map.centerAndZoom(point, 11);

            if (that.startCityNameCh) {
                map.centerAndZoom(that.startCityNameCh, 15); // 用城市名设置地图中心点
            }

            that.distance = 0
        },

        // 高德地图
        //第一步  创建出地图
        DrivingPath() {
            let that = this
                //基本地图加载
            var map = new AMap.Map("mapBaidu", {
                //resizeEnable: true,
                center: [106.230909, 38.487193], //地图中心点
                zoom: 3, //地图显示的缩放级别
                lang: "en" //可选值：en，zh_en, zh_cn
            });
            //构造路线导航类
            var driving = new AMap.Driving({
                map: map,
                //panel: "panel"
                hideMarkers: false, //是否显示图标 true为不显示
                autoFitView: true,
            });
            // 根据起终点名称规划驾车导航路线
            driving.search([
                    { keyword: this.startCityNameCh, city: this.startCityNameCh },
                    { keyword: this.endCityNameCh, city: this.endCityNameCh }
                ],
                // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
                function(status, result) {
                    //console.log('result'  +   JSON.stringify(result));
                    // that.startLng = result.origin.lng
                    // that.startLat = result.origin.lat
                    // that.endLng = result.destination.lng
                    // that.endLat = result.destination.lat
                    //     // 设置中心点
                    // that.centerLng = (Number(that.startLng) + Number(that.endLng)) / 2
                    // that.centerLat = (Number(that.startLat) + Number(that.endLat)) / 2
                        // console.log(that.centerLng, that.centerLat,"中心点", that.zoom,that.distance)
                        // map.setCenter([that.centerLng, that.centerLat]); //设置地图中心点
                    if (status === 'complete') {
                        //console.log('result'  +   JSON.stringify(result));

                        //   var markers=[
                        //     {position:[result.origin.lng,result.origin.lat]},
                        //     {position:[result.destination.lng,result.destination.lat]}
                        //   ]

                        //   markers.forEach(function(marker) {
                        //     new AMap.Marker({
                        //         map: map,
                        //         icon:'../../../static/img/toumIcon.png',
                        //         position:[marker.position[0], marker.position[1]],
                        //         offset:new AMap.Pixel(-13, -30)
                        //     });


                        // });

                        // //自适应中心点、展示所有标记点--核心代码
                        //   var newCenter = map.setFitView();
                        //   newCenter.getCenter();

                        //设置标注起始地
                        var markerText = new AMap.Marker({
                          position: [result.origin.lng,result.origin.lat],
                          icon: '../../../static/img/toumIcon.png',
                          // offset: new AMap.Pixel(-13, -30)
                        });
                        markerText.setMap(map)

                        markerText.setLabel({
                          offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
                          content: "<div class='AMapinfo'>"+that.startCityNameEn1+"</div>", //设置文本标注内容
                          direction: 'top' //设置文本标注方位
                        });

                         //设置标注目的地
                         var markerText2 = new AMap.Marker({
                          position: [result.destination.lng,result.destination.lat],
                          icon: '../../../static/img/toumIcon.png',
                          // offset: new AMap.Pixel(-13, -30)
                        });
                        markerText2.setMap(map)

                        markerText2.setLabel({
                          offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
                          content: "<div class='AMapinfo'>"+that.endCityNameEn1+"</div>", //设置文本标注内容
                          direction: 'top' //设置文本标注方位
                        });


                        if (that.startCityNameCh == that.endCityNameCh) {
                            map.setZoom(6)
                            that.distance = 0;
                            // that.zoom = 6;
                        } else {
                            that.distance = parseInt(result.routes[0].distance) / 1000
                            // that.zoom = 3;
                           
                        }



                    } else {
                        //console.log('获取驾车数据失败：');
                        //log.error('获取驾车数据失败：' + result)
                    }
                   

                    // 根据距离区分设置zoom
                    // if (Number(that.distance) >= 2000) {
                    //     that.zoom = 3
                    // }
                    // if (Number(that.distance) >= 1500 && Number(that.distance) < 2000) {
                    //     that.zoom = 4
                    // }
                    // if (Number(that.distance) >= 600 && Number(that.distance) < 1500) {
                    //     that.zoom = 5
                    // }
                    // if (Number(that.distance) <= 600 && Number(that.distance) > 200) {
                    //     that.zoom = 6
                    // }
                    // if (Number(that.distance) <= 200 && Number(that.distance) > 100) {
                    //     that.zoom = 7
                    // }
                    // if (Number(that.distance) <= 100 && Number(that.distance) > 50) {
                    //     that.zoom = 8
                    // }
                    // if (Number(that.distance) <= 50 && Number(that.distance) > 30) {
                    //     that.zoom = 9
                    // }
                    // if (Number(that.distance) <= 30 && Number(that.distance) > 10) {
                    //     that.zoom = 11
                    // }
                    // if (Number(that.distance) <= 10 && Number(that.distance) >= 0) {
                    //     that.zoom = 13
                    // }
                    // 根据距离区分设置zoom
                    // map.setZoomAndCenter(that.zoom, [result.destination.lng, result.destination.lat]); //同时设置地图层级与中心点
                    //that.mapShow = true
                });

        },
       
        //=========================起运城市，目的城市值======================//
        sentStartMsgSev(msg) {
            this.startCityNameCh = msg.StartProvNameCh + msg.StartCityNameCh
            this.startCityNameEn = msg.StartCityNameEn
            this.startCityKey = msg.StartCityKey
        },
        sentEndMsgSev(msg) {
            this.endCityNameCh = msg.EndProvNameCh + msg.EndCityNameCh
            this.endCityNameEn = msg.EndCityNameEn
            this.endCityKey = msg.EndCityKey
        },

        //=====预约时间选择器=========//
        setServTimeApi() {
            let that = this
            this.api.param = {
                channelType: 1,
            }
            // this.api.url = this.$api01 + "/api/InfoCustomer/PickupChannel/ServiceTimeEn"
            this.api.url = this.$api04 + "/Pickup/api/PickupChannel/ServiceTimeEn"
            fetch(this.api.url, this.api.param).then(function(res) {
                if (res.IsOK) {
                    that.servTimeOptions = []
                    res.Results.forEach((e) => {
                        if (e.Weeks == 1) {
                            e.Weeks = 'Monday'
                        }
                        if (e.Weeks == 2) {
                            e.Weeks = 'Tuesday'
                        }
                        if (e.Weeks == 3) {
                            e.Weeks = 'Wednesday'
                        }
                        if (e.Weeks == 4) {
                            e.Weeks = 'Thursday'
                        }
                        if (e.Weeks == 5) {
                            e.Weeks = 'Friday'
                        }
                        if (e.Weeks == 6) {
                            e.Weeks = 'Saturday'
                        }
                        if (e.Weeks == 0) {
                            e.Weeks = 'Sunday'
                        }
                        if (e.Day == 1) {
                            e.Day = 'Today'
                        }
                        if (e.Day == 2) {
                            e.Day = ''
                        }
                        if (e.Day == 3) {
                            e.Day = ''
                        }
                    })

                    res.Results.forEach((m) => {
                        //let labelText =
                        let one = {
                            label: !m.Day ? m.Date + '(' + m.Weeks + ')' : m.Date + '(' + m.Weeks + ' , ' + m.Day + ')',
                            value: m.Date,
                            children: []
                        }
                        that.servTimeOptions.push(one)

                        m.Times.forEach((m1) => {
                            let two = {
                                label: m1.Time,
                                value: m1.Time
                            }
                            one.children.push(two)
                        })
                    })
                }
            })
        },
        handleChange() {
            if (this.mentTime) {
                this.selectedOptionsTip = false
                this.plaCas = ''
            }
        },

        //重量，体积
        chgWei() {
            if (this.carWeight) {
                this.tipsTextVol = false
            }

        },
        chgVol() {
            if (this.carVolume) {
                this.tipsTextVol = false
            }
        },
        //验证数字
        checkNum(ctrValue) {
            if (ctrValue) {
                ctrValue = ctrValue.replace(/[^\d\.]/g, '');
                if (ctrValue.indexOf('.') > -1) {
                    let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
                    if (s.length > 3) {
                        ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 4);
                    }
                }
                //获取小数点前面的值
                let arr = ctrValue.split(".");
                let le = arr[0].length;

                if (le > 8) {
                    let int = arr[0].substring(0, 8);
                    if (ctrValue.indexOf('.') > -1) {
                        ctrValue = int + '.' + arr[1];
                    } else {
                        ctrValue = int
                    }
                }
                return ctrValue;
            }
        },
        //===查价按钮=====//
        async clkEnquiry() {
            this.currentPage = 1;

            this.$refs.pickupStartText.showTips(); //起运城市
            this.$refs.pickupStartText.sentMsgToService(); //起运城市传值

            this.$refs.pickupEndText.showTips(); //目的城市
            this.$refs.pickupEndText.sentMsgToService(); //目的城市传值到

            if (!this.carWeight && !this.carVolume) {
                this.tipsTextVol = true
            }

            if (!this.mentTime) {
                this.selectedOptionsTip = true
                this.plaCas = 'Required'
            }

            if (!this.startCityNameEn || !this.endCityNameEn || this.tipsTextVol || !this.mentTime) {
                return false
            }

            // this.checkPrice('Pick-up service',this.startCityNameEn,'',this.endCityNameEn,'','',
            // Number(this.carWeight),Number(this.carVolume),0,false,[],false,'')

            this.startCityNameEn1 = this.startCityNameEn
            this.endCityNameEn1 = this.endCityNameEn
            await this.QueryThPriceApi(); //调用查价接口

        //    try {
        //         this.DrivingPath();//高德地图
        //     } catch (error) {
        //         console.log(error);
        //     }


        },
        //===================查价接口==============//
        async QueryThPriceApi() {
            let that = this
                //let time=this.mentTime.join(' ')
            let time = new Date(this.mentTime).Format('yyyy-MM-dd 23:59:59')
            this.api.param = {
                PlanDate: time, //预计取件时间
                ShipmentUnit: this.radioUnits, //单位类型，0：KG/CBM，1：LB/CFT ,
                Weight: this.carWeight, //重量
                Volume: this.carVolume, //体积
                THFreightKey: '', //渠道key
                ChannelType: 1, //渠道类型（0：中文渠道，1：海外渠道） ,
                StartCityKey: this.startCityKey, //起运城市key
                StartCityAreaKey: '', //起运区域key
                EndCityKey: this.endCityKey, //目的城市key
                EndCityAreaKey: '', //目的城市区域key
                ResponseType: 0, //响应类型，0：分页的，1：所有的，2：最便宜的 ,
                Skip: this.currentPage - 1,
                Take: this.pageSize,
            }
            this.showList = 2
            this.api.url = this.$api01 + "/api/InfoCustomer/PickupCalculation/QueryPrice"
            await post(this.api.url, this.api.param).then(function(res) {

                that.searchResult(res.Total,'Pick-up service',that.startCityNameEn,'',that.endCityNameEn,'',false)
                
                that.showList = 1
                if (res.IsOK) {
                    that.ThQueryList = res.Results
                    that.total = res.Total
                } else {
                    this.showList = 1;
                    that.total = 0;
                    this.ThQueryList = []
                }
            })
        },

        //点击下单按钮
        clkSelectBtn(item) {

            //判断预约提货时间是否大于当前时间 +30分钟  栗子：选择19:00:00 当前时间超过了18:30:00  就无服
            let text1 = 'There is no service for the scheduled delivery time. Please change it and try again'


            let time = new Date(this.mentTime).Format('yyyy-MM-dd 23:59:59')

            //  let date1=new Date(); //开始时间
            //  //let time=this.mentTime.join(' ')
            //  let date2=new Date(time); //结束时间
            //  let date3 =date2.getTime()-date1.getTime()  //时间差的毫秒数
            //  //计算相差多少分钟  1min=60s  1s=1000ms
            //  let dateMin=Math.round((date3/1000)/60)

            //  if(dateMin<30){
            //     this.PopTime(text1)
            //     return false
            //  }
            // this.yzSuccess = true
            var newWindow = window.open()
            newWindow.location.href='/pickUp/pickUpOrder'+
            '?startCityNameEn='+this.startCityNameEn+
            '&endCityNameEn='+this.endCityNameEn+
            '&StartCityAreaKey='+item.StartCityAreaKey+
            '&EndCityAreaKey='+item.EndCityAreaKey+
            '&StartCityKey='+item.StartCityKey  +
            '&EndCityKey='+item.EndCityKey +
            '&PlanDate='+time+
            '&ArrivalTime='+item.ArrivalTime+
            '&Weight='+item.Weight+
            '&Volume='+item.Volume+
            '&ChargeWeight='+item.ChargeWeight+
            '&THFreightKey='+item.THFreightKey+
            '&PickupFee='+item.PickupFee
            // this.$router.push({
            //     path: "/pickUp/pickUpOrder",
            //     query: {
            //         startCityNameEn: this.startCityNameEn,
            //         endCityNameEn: this.endCityNameEn,
            //         StartCityAreaKey: item.StartCityAreaKey,
            //         EndCityAreaKey: item.EndCityAreaKey,
            //         StartCityKey: item.StartCityKey,
            //         EndCityKey: item.EndCityKey,
            //         PlanDate: time,
            //         ArrivalTime: item.ArrivalTime,
            //         Weight: item.Weight,
            //         Volume: item.Volume,
            //         ChargeWeight: item.ChargeWeight,
            //         THFreightKey: item.THFreightKey,
            //         PickupFee: item.PickupFee
            //     }
            // })
        },

        //提示无服务时间弹窗
        PopTime(text) {
            this.$confirm(text, '', {
                customClass: 'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                showCancelButton: false, //去掉取消按钮
                showClose: false, //去掉右上角的取消（X）
                // type: 'warning',
                center: true
            }).then(() => {

            }).catch(() => {

            });
        },

        //分页
        /*================分页开始==========================*/
        handleSizeChange(val) {
            this.pageSize = val
            this.statusChked = false;
            this.QueryThPriceApi()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.statusChked = false;
            this.QueryThPriceApi()
        },
    },
    // // 离开路由 如果是去向编辑也就缓存
    // beforeRouteLeave(to, from, next) {
    //     if (to.path == '/pickUp/pickUpOrder') {
    //         //缓存
    //         from.meta.keepAlive = true;
    //     } else {
    //         //不缓存
    //         from.meta.keepAlive = false;
    //     }
    //     next()
    // },
    // // 回退后页面需要查一次价
    // beforeRouteEnter(to, from, next) {
    //     from.meta.keepAlive = false
    //     next(vm => {
    //         if (from.path == '/pickUp/pickUpOrder') {
    //             if (vm.yzSuccess) {
    //                 vm.clkEnquiry()
    //             }
    //         }
    //     });
    // },

};






// WEBPACK FOOTER //
// ./src/assets/js/userCenter/pickup/pickupService.js